import { factoryService, getJsonRequest, postJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL, REACT_APP_API_PRINCIPAL_URL } from '../config/settings/environment'

/**
 * Gets initials props to validated inputs types.
 */
export const getConfigData = factoryService(() => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/parametros/solicitudCotizacion`)
})

/**
 * Gets the list of Regions types.
 */
export const getRegion = factoryService(() => {
  return getJsonRequest(`${REACT_APP_API_PRINCIPAL_URL}/v1/geografia/region`)
})

/**
 * Gets the list of Districts types.
 */
export const getDistricts = factoryService(({ stateID }) =>
  getJsonRequest(`${REACT_APP_API_PRINCIPAL_URL}/v1/geografia/region/${stateID}/comuna`)
)

/**
 * Gets the list of units measure.
 */
export const getUnitsMeasure = factoryService(() =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/catalogo/unidades`)
)

/**
 * Gets the list of units measure.
 */
export const getTaxation = factoryService(() =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/catalogo/impuestos?activo=1`)
)

/**
 * Gets the user unit info contained in the token.
 */
export const getUserUnitsInfo = factoryService(() => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/usuario/unidadesEnterprise`)
})

/**
 * Gets the onboarding status.
 */
export const getOnboardingStatus = factoryService(() =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/tutorial`)
)

/**
 * Updates the onboarding status.
 */
export const updateOnboardingStatus = factoryService(() =>
  postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/tutorial`)
)
